import React from "react";
import { Link } from "react-router-dom";

const SingleShop = ({ image, name, title, index }) => {
  return (
    <>
      <div className="col-lg-3 col-md-6">
        <div className="product mb-40">
          <div className="product__img">
            <Link to="#">
              <img src={`/${image}`} alt="" />
            </Link>
          </div>
          <div className="product__content text-center pt-30">
            <h4 className="pro-title">
              <Link to={"/products/cell-marque-detail/" + index}>{title}</Link>
            </h4>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleShop;
